import { render, staticRenderFns } from "./CustomerOrders.vue?vue&type=template&id=ba5f863c&scoped=true"
import script from "./CustomerOrders.vue?vue&type=script&lang=js"
export * from "./CustomerOrders.vue?vue&type=script&lang=js"
import style0 from "./CustomerOrders.vue?vue&type=style&index=0&id=ba5f863c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5f863c",
  null
  
)

export default component.exports